export const APPT_STATUS = {
  requested_by_athlete: { label: "Requested", color: "#F59E0B" },
  proposed_by_coach: { label: "Proposed", color: "#F59E0B" },
  alternate_proposed: { label: "Alternate proposed", color: "#F59E0B" },
  confirmed: { label: "Confirmed", color: "#22C55E" },
  in_progress: { label: "In progress", color: "#22D3EE" },
  completed: { label: "Completed", color: "#94A3B8" },
  declined: { label: "Declined", color: "#EF4444" },
  cancelled_by_coach: { label: "Cancelled by coach", color: "#EF4444" },
  cancelled_by_athlete: { label: "Cancelled by athlete", color: "#EF4444" },
  expired: { label: "Expired", color: "#64748B" },
};

export const fmtTime = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString(undefined, {
      weekday: "short", month: "short", day: "numeric", hour: "numeric", minute: "2-digit",
    });
  } catch { return iso; }
};

export const joinable = (a) => {
  if (!["confirmed", "in_progress"].includes(a.status)) return false;
  if (!a.start_at) return true;
  const start = new Date(a.start_at).getTime();
  const end = start + (a.duration_minutes || 30) * 60000 + 120 * 60000;
  const now = Date.now();
  return now >= start - 30 * 60000 && now <= end;
};
